/* eslint-disable jsx-a11y/anchor-is-valid */
import './StudentLessonSummary.scss';
import { Fade } from '@mui/material';
import { useDomain } from '../../../../states/AppDomainProvider';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  data: null,
  subjectId: null,
};

const StudentLessonSummary = (props) => {
  const { data, subjectId } = { ...defaultProps, ...filterUndefined(props) };
  const { userDomain } = useDomain();
  const { userProfile } = userDomain.domainData;
  const subjectFromProfile = userProfile.subjects;

  const subject = subjectFromProfile.find((s) => s.id === subjectId);

  if (userProfile.convenience && subject.lessons.length > 0) {
    return (
      <Fade timeout={1000} in>
        <div className='student-lesson-summary-expire-lessons'>
          No assignments today, but you can work on these previous lessons.
        </div>
      </Fade>
    );
  } else {
    if (!data || data.key <= 0) {
      return null;
    }
    const numberOfLessons = data.key.length;
    return (
      <Fade timeout={1000} in>
        <div className='student-lesson-summary'>
          {numberOfLessons} {numberOfLessons > 1 ? 'Activities' : 'Activity'} completed today
        </div>
      </Fade>
    );
  }
};

export default StudentLessonSummary;
